import * as z from "zod";
import { defineStreamChannelSchema } from "./definitions";

export const streamTestTransportSchema = z.enum(["redis", "notice"]);
export type StreamTestTransportName = z.infer<typeof streamTestTransportSchema>;

export const streamTestEventSchema = z.object({
  _tag: z.literal("streamTestEvent"),
  eventId: z.string(),
  transport: streamTestTransportSchema,
  note: z.string(),
  /** Epoch ms stamped once at publish, so both transports share it. */
  publishedAt: z.number(),
});
export type StreamTestEvent = z.infer<typeof streamTestEventSchema>;

export const streamTestStreamInputSchema = z.object({});
export type StreamTestStreamInput = z.infer<typeof streamTestStreamInputSchema>;

/** Redis streams retain history, so the redis channel replays on subscribe. */
export const streamTestReplaySchema = z.object({
  _tag: z.literal("streamTestReplay"),
  events: z.array(streamTestEventSchema),
});
export type StreamTestReplay = z.infer<typeof streamTestReplaySchema>;

export const streamTestRedisStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: streamTestEventSchema,
  initialSchema: streamTestReplaySchema,
  inputSchema: streamTestStreamInputSchema,
});

/** Notice is fire-and-forget with no history, hence no initial payload. */
export const streamTestNoticeStreamChannelSchema = defineStreamChannelSchema({
  eventSchema: streamTestEventSchema,
  initialSchema: z.undefined(),
  inputSchema: streamTestStreamInputSchema,
});
